import { render, staticRenderFns } from "./EditorShareV2Modal.vue?vue&type=template&id=330b4b59&scoped=true&"
import script from "./EditorShareV2Modal.vue?vue&type=script&lang=js&"
export * from "./EditorShareV2Modal.vue?vue&type=script&lang=js&"
import style0 from "./EditorShareV2Modal.vue?vue&type=style&index=0&id=330b4b59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330b4b59",
  null
  
)

export default component.exports